module.exports = __webpack_public_path__ + "img/inverted-bg.8139625.png";